import React from 'react';
import PropTypes from 'prop-types';
import './CustomTooltip.scss';

export default function CustomTooltip({open, title, placement = 'bottom'}) {
  if (!open) return null;

  return <span className={`Avada-Faqs-Custom-Tooltip ${placement}`}>{title}</span>;
}

CustomTooltip.propTypes = {
  title: PropTypes.any,
  open: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'bottom'])
};
